import { isType } from "@/utils/common.utils";

/** Default title of the application */
const { VUE_APP_TITLE } = process.env;

/**
 * Title mixin to change the doccument title on the basis of current page
 * @author {Jatin Kamboj}
 */
export default {
  /**
   * Created lifecycle hook
   */
  created() {
    // Updates the title of the page when the component is created
    this.updateTitle();
  },
  methods: {
    /**
     * Returns the title of the view component
     * @returns {String} title of the vue page
     */
    getTitle() {
      const { title } = this.$options;

      if (title) {
        return isType(title, "function") ? title(this) : title;
      }
    },
    /**
     * Updates the title of the page
     */
    updateTitle() {
      let title = this.getTitle();
      // If no title is found in the component it fallbacks to default title
      if (!title) title = VUE_APP_TITLE;
      document.title = title;
    },
  },
};
